import { Autocomplete, TextField } from '@mui/material';
import { LookupRecord } from '../../../api/masterData';

interface SearchableLookupFieldProps {
  label: string;
  options: LookupRecord[] | undefined;
  value: number | '';
  onChange: (id: number | '') => void;
  getFlag?: (option: LookupRecord) => string | undefined;
  required?: boolean;
  size?: 'small' | 'medium';
}

/** MUI Autocomplete-backed searchable dropdown for master-data lookups
 * (countries, universities, etc.) — no extra dependency needed. */
export const SearchableLookupField = ({
  label,
  options,
  value,
  onChange,
  getFlag,
  required,
  size,
}: SearchableLookupFieldProps) => {
  const selected = options?.find((o) => o.id === value) ?? null;

  return (
    <Autocomplete
      fullWidth
      size={size}
      options={options ?? []}
      getOptionLabel={(option) => String(option.name)}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      value={selected}
      onChange={(_e, newValue) => onChange(newValue ? (newValue.id as number) : '')}
      renderOption={(props, option) => {
        const flag = getFlag?.(option);
        return (
          <li {...props} key={option.id as number}>
            {flag ? `${flag} ` : ''}
            {String(option.name)}
          </li>
        );
      }}
      renderInput={(params) => <TextField {...params} label={label} required={required} />}
    />
  );
};
